export enum OrderStatus {
  NEW = 'NEW', // mới đặt nhưng chưa cọc
  LOCKED = 'LOCKED', //  đã cọc
  CANCELLED = 'CANCELLED', // huỷ
  CHECKIN = 'CHECKIN', // đã checkin
  CHECKOUT = 'CHECKOUT', // đã checkout
  CONFLICT = 'CONFLICT', // trùng lịch
}
